import React, { useRef, useState } from "react";
import { playIcon } from "../../../Components";

export default function GalleryVideo({ setShowActionIcon, ...props }) {
  console.log(props)
  const video = useRef(null);
  const [videoState, setVideoState] = useState(false);
  const playBtnClick = () => {
    video?.current?.play();
    //setShowActionIcon(false)
    setVideoState(true);

  };
  const pauseBtnClick = () => {
    video?.current?.pause();
    setVideoState(false);
    setShowActionIcon(false)
  };
  return (
    <div className={"assets__media vid " + (videoState ? " active" : "")}>
      <video
        ref={video}
        src={process.env.PUBLIC_URL + props.media_url}
        muted
        onEnded={() => setVideoState(false)}
        className={"galleryVideo " + props.status == "hide" ? "grayOutImage" : ""}
      ></video>
      {props.status == "visible" &&
        <>
          <button className="button play" onClick={playBtnClick}>
            {playIcon}
          </button>
          <button className="button pause" onClick={pauseBtnClick}></button>
        </>}
      {props.status == "hide" &&
        <>
          <button className="button play" >
            {playIcon}
          </button>
          <button className="button pause" onClick={pauseBtnClick}></button></>}
    </div>
  );
}
